import { DataItem } from '@cad-arc'
import { compact } from 'lodash';
import { IOption } from '@mark43/cad-api';

export function FilterSummary({
    label,
    options,
    option,
    stringValues,
    stringValue,
    numberValue,
    booleanValue,
}: Readonly<{
    label: string;
    options?: IOption[];
    option?: IOption;
    stringValues?: (string | undefined)[];
    stringValue?: string;
    numberValue?: number;
    booleanValue?: boolean;
}>) {
    let formattedFilters = null;
    if (options && options.length > 0) {
        formattedFilters = options.map((option) => option.label).join(', ');
    } else if (option) {
        formattedFilters = option.label;
    } else if (stringValues) {
        formattedFilters = compact(stringValues)
            .filter((value) => !!value)
            .map((value) => value.trim())
            .filter((value) => value.length > 0)
            .join(', ');
    } else if (stringValue && stringValue.trim().length > 0) {
        formattedFilters = stringValue;
    } else if (numberValue !== undefined) {
        formattedFilters = `${numberValue}`;
    } else if (booleanValue !== undefined) {
        formattedFilters = booleanValue ? 'Yes' : 'No';
    }
    if (formattedFilters) {
        return <DataItem dataKey={label}>{formattedFilters}</DataItem>;
    }
    return null;
}
